import { User } from 'lucide-react';
import { formatContactRole } from '../utils/entity-formatters';

interface SecondaryContactsListProps {
  contacts: Array<{
    name: string;
    email: string;
    phone: string;
    role: string;
    title: string;
  }>;
}

export const SecondaryContactsList = ({
  contacts,
}: SecondaryContactsListProps) => {
  if (contacts.length === 0) return null;

  return (
    <div className="mt-6">
      <h4 className="font-medium mb-3 flex items-center">
        <User className="h-4 w-4 mr-1" />
        Secondary Contacts
      </h4>
      <div className="space-y-3">
        {contacts.map((contact) => (
          <div
            key={contact.email}
            className="pt-2 rounded-lg hover:bg-muted transition-colors"
          >
            <div className="flex flex-col space-y-2">
              <div>
                <p className="font-medium text-foreground">{contact.name}</p>
                {contact.title && (
                  <p className="text-sm text-muted-foreground">
                    {contact.title}
                  </p>
                )}
              </div>
              <div className="flex flex-wrap gap-4 text-sm">
                <div>
                  <span className="text-muted-foreground mr-1">Role:</span>
                  <span className="text-foreground">
                    {formatContactRole(contact.role)}
                  </span>
                </div>
                <div>
                  <span className="text-muted-foreground mr-1">Email:</span>
                  <a
                    href={`mailto:${contact.email}`}
                    className="text-blue-600 hover:underline"
                  >
                    {contact.email}
                  </a>
                </div>
                <div>
                  <span className="text-muted-foreground mr-1">Phone:</span>
                  <a
                    href={`tel:${contact.phone}`}
                    className="text-foreground hover:underline"
                  >
                    {contact.phone}
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
